import formatDateFromUtcToTimezone from 'app/utils/formatDateFromUtcToTimezone';
import { ExamsDetailsContentsState, ExamsDetailsState, ExamsResultState } from './types';

const contents: ExamsDetailsContentsState = {
  startTitle: 'Gostaria de iniciar a avaliação %examName%?',
  startMessage: '',

  finishTitle: 'Deseja finalizar sua avaliação?',
  finishMessage: '',

  incompleteTitle: 'Ops, existem perguntas não respondidas, deseja enviar mesmo assim?',
  incompleteMessage: '',

  approvedTitle: 'Parabéns, você foi bem.',
  approvedMessage: '',

  reprovedTitle: 'Não foi dessa vez.',
  reprovedMessage: '',

  resultsTitle: 'Resultado será liberado em %resultDate%.',
  resultsMessage: '',
};

export const defaultContent = (exam: ExamsDetailsState, result?: ExamsResultState) => {
  if (!exam) {
    return contents;
  }

  return Object.keys(contents).reduce((prev, contentKey) => {
    const field = contentKey as keyof ExamsDetailsContentsState;

    let content = contents[field];

    if (exam[field]) {
      content = exam[field];
    }

    content = content.replace('%examName%', exam?.name);

    if (result) {
      if (result?.resultDate) {
        content = content.replace('%resultDate%', formatDateFromUtcToTimezone(result?.resultDate).format('DD/MM/YYYY [às] HH:mm'));
      }
    }

    return { ...prev, [field]: content };
  }, {} as ExamsDetailsContentsState);
};
